/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Layout from "../../../../Layouts/Layout";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import Container from "../../../../../components/Container/Container";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import LpAdvocardMeta from "./LpAdvocardMeta";
import ContractCheckin from "../../../../../components/Checkin/ContractCheckin/ContractCheckin";
import HowItWorksSectionContract from "../../../../../components/Sections/Contract/HowItWorksSection/HowItWorksSectionContract";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { contractTeaserCards } from "../../../../../services/landingPageService";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";
import { PARTNER_IRIS } from "../../../../../constants/partnerIris";

const LpContractAdvocard = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpAdvocardMeta
        title={"Professionelle Hilfe im Vertragsrecht | Legalbird"}
        description={"Professionelle Hilfe im Vertragsrecht - Schnell, einfach und sicher! Jetzt beraten lassen!"}
      />
      <LandingPageTeaser
        teaserButtonText={"Jetzt Starten"}
        headline={"Fragen oder Probleme im Bereich Vertragsrecht?"}
        subheadline={"Wir sorgen dafür, dass Sie zu Ihrem Recht gelangen!"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={contractTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={PARTNER_IRIS.ADVOCARD} containerStyle={"settlementContainer"} />
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <ContractCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
          </Container>
        )}
        <HowItWorksSectionContract />
      </GreyBackgroundWrapper>
      <AttorneySection
        textCards={false}
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <ContractCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
    </Layout>
  );
};

export default LpContractAdvocard;
